export const ICON_LABELS = {
  CONTENT_COPY: "content_copy_rounded",
  DONE: "done_rounded",
  ADD: "add_rounded",
  FOLDER: "folder_rounded",
  MOVE: "drive_file_move_rounded",
  DELETEICON: "delete_outline_rounded",
  VIEW_ICON: "sort_rounded",
  ADD_WIDGET: "dashboard_customize_rounded",
  ACTION_ARROW: "keyboard_arrow_down_rounded",
  PERSON: "person_rounded",
  EVENT_NOTE: "event_note_rounded",
  SKIP_NEXT: "skip_next_rounded",
  CHECK_CIRCLE: "check_circle_rounded",
  ARROW_BACK: "arrow_back_rounded",
  VIEW_WEEK: "view_week_rounded",
  CHECK: "check_rounded",
  CLOUD_DOWNLOAD: "cloud_download_rounded",
  MAIL_LOCK: "mail_lock_rounded",
  EDIT: "edit_rounded",
  LINK: "link_rounded",
  PUSH_PIN: "push_pin_rounded",
  DELETE: "delete_rounded",
  DELETE_OUTLINE: "delete_outline_rounded",
  APARTMENT: "apartment_rounded",
  INSERT_DRIVE_FILE: "insert_drive_file_rounded",
  CALL: "call_rounded",
  EMAIL: "email_rounded",
  INSERT_LINK: "insert_link_rounded",
  RADIO_BUTTON_UNCHECKED: "radio_button_unchecked_rounded",
  NAVIGATE_NEXT: "navigate_next_rounded",
  HELP_OUTLINE: "help_outline_rounded",
  NOTIFICATIONS_NONE: "notifications_none_rounded",
  SETTINGS: "settings_rounded",
  CURRENCY_EXCHANGE: "currency_exchange_rounded",
  LOGOUT: "logout_rounded",
  ACCESS_TIME: "access_time_rounded",
  VISIBILITY_OFF: "visibility_off_rounded",
  VISIBILITY_ON: "visibility_rounded",
  BOOKMARK: "bookmark_rounded",
  SAVE: "save_rounded",
  CONTACT_PAGE: "contact_page_rounded",
  FILTER_ALT: "filter_alt_rounded",
  CLOSE_BUTTON: "close_button_rounded",
  DOWNLOAD: "download_rounded",
  VIEW_WEEK_ROUNDED: "view_week_rounded",
  ADD_CIRCLE_OUTLINE: "add_circle_outline_rounded",
  CONTENT_COPY: "content_copy",
  DONE: "done",
  ADD: "add",
  FOLDER: "folder",
  DRIVE_FILE_MOVE: "drive_file_move",
  SORT: "sort",
  DASHBOARD_CUSTOMIZE: "dashboard_customize",
  KEYBOARD_ARROW_DOWN: "keyboard_arrow_down",
  PERSON: "person",
  EVENT_NOTE: "event_note",
  SKIP_NEXT: "skip_next",
  CHECK_CIRCLE: "check_circle",
  ARROW_BACK: "arrow_back",
  VIEW_WEEK: "view_week",
  CHECK: "check",
  CLOUD_DOWNLOAD: "cloud_download",
  MAIL_LOCK: "mail_lock",
  EDIT: "edit_rounded",
  LINK: "link",
  PUSH_PIN: "push_pin",
  APARTMENT: "apartment",
  INSERT_DRIVE_FILE: "insert_drive_file",
  CALL: "call",
  EMAIL: "email",
  RADIO_BUTTON_UNCHECKED: "radio_button_unchecked",
  NAVIGATE_NEXT: "navigate_next",
  HELP_OUTLINE: "help_outline",
  NOTIFICATIONS_NONE: "notifications_none",
  SETTINGS: "settings",
  CURRENCY_EXCHANGE: "currency_exchange",
  LOGOUT: "logout",
  ACCESS_TIME: "access_time",
  VISIBILITY_OFF: "visibility_off",
  VISIBILITY_ON: "visibility",
  BOOKMARK: "bookmark",
  SAVE: "save",
  CONTACT_PAGE: "contact_page",
  FILTER_ALT: "filter_alt",
  CLOSE_BUTTON: "close_button",
  FILE_UPLOAD: "file_upload_rounded",
  FACT_CHECK: "fact_check_rounded",
  TASK: "task_rounded",
  DNS_ROUNDED: "dns_rounded",
  DRAG_INDICATOR_ROUNDED: "drag_indicator_rounded",
  MANAGE_SEARCH: "manage_search",
  CAMPAIGN: "campaign",
  TRENDING_UP: "trending_up",
};
